<template>
  <div class="row">
    <div class="contain-all Bold">
      <div class="center-all content-1320px">
        <Breadcrumbs class="breadcrumbs-magazineAll magazine-bread" ref="breadcrumbs"></Breadcrumbs>
        <innerTab v-bind:childLogGaEvent="childLogGaEvent" class="innerTabAll" ref="inTab"></innerTab>

        <div class="digital-marketing col-xs-12 col-sm-12 col-md-12" ref="digitalMarketing">
          <div class="logo-01All">
            <div class="logo-01All-placeImg">
              <img src="../images/logo02.png" alt />
            </div>
          </div>

          <div class="header magezine-select-inner">
            <div class="magezine-select-all Bold" @click="magezineSelectAll">
              <div class="magezine-select" v-on:click="selectMagezine" role="combobox" :aria-label="magazineP">
                <p class="digital-marketing-title" v-if="magazineP">
                  <a href="javascript:;" style="color: inherit">{{magazineP}}</a>
                </p>
                <i class="icon-arrow-down magezine-select-icon Bold"></i>
              </div>
              <div class="magezine-select-list">
                <div class="digital-marketing-title magezine-select-item" @click="closePopup">
                  {{$t('message.Select Issue')}}
                  <i class="icon-arrow-down magezine-select-icon Bold"></i>
                </div>
                <div
                  class="digital-marketing-title magezine-select-item"
                  :class="{orangeChenge:magazineId == magazine.id}"
                  v-on:click="selectIssue(magazine.id,magazine,'',index)"
                  v-for="(magazine,index) in magazineList"
                  :key="index"
                  role="option"
                  :aria-label='$store.getters.getObject(magazine.langMap).title'
                >
                  <a href="javascript:;" style="color: inherit">{{$store.getters.getObject(magazine.langMap).title}}</a>
                </div>
              </div>
              <div
                class="mask maskJia"
                @click="closePopup"
                :class="{'show':(showJobFunction||showExperience),'maskPC':$store.state.innerWidth>768}"
              ></div>
            </div>
          </div>
        </div>

        <div class="col-md-12 digital digital-marketing-content" v-if="sideStory.length !=0">
          <div class="col-xs-12 col-sm-12 col-md-7 pad-0" style="position: sticky; top: -60px">
            <div class="magazineAll-title-oneInner Bold">
              <h2 class="background-title magazineAll-title-one">
                {{$t('message.The Headline')}}
                <img src="../images/Vector Smart Object1.png" />
              </h2>
            </div>
            <div class="digital-contain" @click="goMagazineDetail(sideStory[0])">
              <div class="digital-marketing-placeImg">
                <div class="digital-marketing-placeImgAdd">
                  <img
                    class="digital-marketing-img"
                    v-bind:src="$store.getters.getObject(sideStory[0].langMap).coverPhoto"
                    :alt="$store.getters.getObject(sideStory[0].langMap).title"
                  />
                </div>
                <div class="orangeAll-placeImg">
                  <img src="../images/orange.png" draggable="false" />
                  <div
                    class="orangeAll-info Bold"
                  >{{$store.getters.getObject(sideStory[0].subCategoryList[0].langMap).content}}</div>
                </div>
                <div></div>
              </div>
              <div class="digital-placeImg-information col-xs-12 col-sm-12 padLR-20">
                <div class="digital-information-title Bold">{{$store.getters.getObject(sideStory[0].langMap).title}}</div>
                <div class="digital-information-detail Regular">
                  <a href="javascript:;" style="color: inherit">
                    {{$store.getters.getObject(sideStory[0].langMap).shortDescription}}
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-5 padLR-20 fspdR-0">
            <div class="Bold">
              <h2 class="background-title magazineAll-title-two">
                {{$t('message.Feature stories')}}
                <img src="../images/dot1.png" />
              </h2>
            </div>
            <div class="digital-marketing-rightList magazineAll-scroll">
              <div
                class="hot-picks-ad hot-picks-adAll digital-marketing-ad"
                v-for="(featureItem,index) in featureStory"
                :key="index"
                @click="goMagazineDetail(featureItem)"
              >
                <div class="col-xs-6 col-sm-6 col-md-8 hot-picks-placeImg pad-0">
                  <img
                    class="hot-picks-img"
                    :src="$store.getters.getObject(featureItem.langMap).coverPhoto"
                    :alt="$store.getters.getObject(featureItem.langMap).title"
                  />
                  <div class="positive"></div>
                </div>
                <div class="col-xs-6 col-sm-6 col-md-4 hot-magazine-info">
                  <div class="hot-picks-subtitle issue-subtitle">
                    {{$store.getters.getObject(featureItem.subCategoryList[0].langMap).content}}
                  </div>
                  <div class="hot-picks-information issue-information">
                    <span class="hover-line issue-hover-line">
                      <a href="javascript:;" style="color: inherit">{{$store.getters.getObject(featureItem.langMap).title}}</a>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="flex-center">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 center-column All-column online-column online-bottomList online-bottomListAll">
        <div class="deco-28All-placeImg">
          <img src="../images/deco-28.png" alt />
        </div>
        <div style="width:100%"  v-if="column.length > 0">
          <div class="magazineAll-title-threeInner Bold">
            <h2 class="background-title magazineAll-title-three">
              {{$t('message.Columns')}}
              <img src="../images/deco-16.png" />
            </h2>
          </div>
          <div class="coursesPC feature-story-inner">
            <div class="col-xs-12 col-sm-12 col-md-12 feature-story pad-0">
              <div class="col-xs-12 col-sm-6 col-md-3 feature-story-item"
                v-for="(item,index) in column"
                :key=index
                @click="goMagazineDetail(item)"
              >
                <div class="col-xs-12 col-sm-12 col-md-12 hot-picks-ad digital-marketing-ad hot-picks-adFeature">
                  <div class="col-xs-6 col-sm-6 col-md-12 hot-picks-placeImg hot-picks-placeImgFeacture pad-0">
                    <img class="hot-picks-img" :src="$store.getters.getObject(item.langMap).coverPhoto" :alt="$store.getters.getObject(item.langMap).title" />
                    <div class="positive"></div>
                  </div>
                  <div class="col-xs-6 col-sm-6 col-md-12 padLeft-0 padRight-0">
                    <div class="issue-tietle Regular">
                         {{$t('message.Issue')}} {{item.issueNumber}}
                    </div>
                    <div class="hot-picks-subtitle feacture-subtitle Bold">{{$store.getters.getObject(item.subCategoryList[0].langMap).content}}</div>
                    <div class="hot-picks-information feacture-information Bold">
                      <span class="hover-line feacture-hover-line">
                        <a href="javascript:;" style="color: inherit">{{$store.getters.getObject(item.langMap).title}}</a>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Breadcrumbs from "@/components/Breadcrumbs";
import { EventBus } from "@/javascripts/eventBus.js";
import innerTab from "@/components/innerTab";
export default {
  name:"onlineMagazine",
  components: {
    Breadcrumbs,
    innerTab
  },
  
  data() {
    return {
      // issueContent:{},
      featureStory: [],
      sideStory: [],
      column: [],
      articleList: [],
      magazineList: [],
      magazineP: "",
      entrySelect: false,
      categoryList: [],
      magazineId: 0,
      showJobFunction: false,
      showExperience: false,
      magazineItem: "",
      louterState:false,
      fromLouterName:"",
    };
  },
  props:[
      "logGaEvent"
  ],
  metaInfo() {
    return {
    }
  },
  created(){},
  
  beforeRouteLeave(to, from, next){ 
    this.fromLouterName = to.name;
      
    if(to.name=='onlineMagazineDetail'){
      to.meta.isUseCache = false;
    }else{
      // to.meta.isUseCache = true;
    }
        next()
  },
  activated(){
    
    if(this.$store.state.formData.headTabState1){
      this.$store.state.formData.headTabState1 = false;
      this.$store.state.selectMenu = 1;
    this.$store.state.mate.title = this.$i18n.t("message.Explorer_talent");
    this.$store.state.mate.description = this.$i18n.t("message.Explorer_desc");
    this.$store.state.mate.keywords = this.$i18n.t("message.Explorer_Keywords");
      this.getCategoryList();
      this.getMagazineList();
     
      this.$refs.inTab.changeInnerTab("All");
    
     
    }
     
  },
  mounted() {
    
    var that = this;
    
    setTimeout(function(){
      that.$store.state.mate.keywords = that.$i18n.t("message.Explorer_Keywords");
      that.$store.state.mate.title = that.$i18n.t("message.Explorer_talent");
    })
    that.$store.state.mate.description = that.$i18n.t("message.Explorer_desc");
    
    // if(this.$store.state.formData.headTabState){
      this.$store.state.selectMenu = 1;
      this.getCategoryList();
      this.getMagazineList();
      this.$refs.inTab.changeInnerTab("All");
     
    // }     
  },
 
  methods: {
    childLogGaEvent:function(eventCategory, eventAction, eventLabel, eventValue) {
        this.logGaEvent(eventCategory, eventAction, eventLabel, eventValue)
    },
    goMagazineDetail: function(item) {
      this.logGaEvent('userClick','goMagazinDetail',item.id)
      this.$router.push({
        path:"/onlineMagazineDetail/" + item.id, 
        query:{
          lang:this.$store.state.language,
          name:this.$store.getters.replaceEvent(this.$store.getters.getObject(item.langMap).title)
        }
      });
    },
    closePopup: function() {
    
      let magezineSelectList = document.getElementsByClassName(
        "magezine-select-list"
      )[0];
      let open = document.getElementsByClassName("open")[0];
      let magezineSelectIcon = document.getElementsByClassName(
        "magezine-select-icon"
      )[0];
      this.showJobFunction = false;
      this.showExperience = false;
      magezineSelectList.classList.remove("open");
      magezineSelectIcon.classList.remove("open");
    },
    getIssueContent: function(magazineId) {
      let that = this;
      this.api.getIssueContent({ magazineId: magazineId }, function(data) {
        // 
        that.issueContent = data.result;
        that.sideStory = [];
        that.featureStory = [];
        that.column = [];
        that.issueContent.forEach(item => {
          if (item.id == 1) {
            that.sideStory = item.articleList;
          } else if (item.id == 2) {
            that.featureStory = item.articleList;
          } else if (item.id == 3) {
            that.column = item.articleList;
          }
        });
      });
    },
    magezineSelectAll: function() {},
    selectMagezine: function() {
      let magezineSelectList = document.getElementsByClassName(
        "magezine-select-list"
      )[0];
      let open = document.getElementsByClassName("open")[0];
      let magezineSelectIcon = document.getElementsByClassName(
        "magezine-select-icon"
      )[0];
      if (open == undefined) {
        magezineSelectList.classList.add("open");
        magezineSelectIcon.classList.add("open");
      } else {
        magezineSelectList.classList.remove("open");
        magezineSelectIcon.classList.remove("open");
      }
      this.showExperience = false;
      this.showJobFunction = !this.showJobFunction;
      if (this.comment.getType()) {
        this.isMobile = true;
      }
    },
    getMagazineList: function() {
      let that = this;
      this.api.getMagazineList({}, function(data) {
        // that.course=data.result;
        // 
        that.magazineList = data.result;
        if(that.$route.params.magazineId){
          that.selectIssue(that.$route.params.magazineId, that.magazineList[0]);
        }else{
          that.selectIssue(that.magazineList[0].id, that.magazineList[0]);
        }
        // setTimeout(()=>{
      
        //   window.scrollTo(0,that.$store.state.formData.onlineMagazineDetailScroll);
        // },400)
        
      });
    },
    selectIssue: function(issueId, magazine, animation) {
      this.logGaEvent('userClick','selectIssue',issueId)
      this.magazineId = issueId;
      // this.magazineId = 11;
      this.magazineItem = magazine;
      if (magazine) {
        this.magazineP =
          this.$i18n.t("message.Issue") +
          " " +
          magazine.issueNumber +
          " " +
          this.$store.getters.getObject(magazine.langMap).title +
          " ";
      }
      this.title = this.$i18n.t("message.Online Magazine")
      let postData = { startRow: 0, maxRows: 10 };

      // 
      //换动画
      if (!animation) {
        if (this.entrySelect) {
          // this.selectMagezine();
          this.closePopup();
        }
        this.entrySelect = true;
      }
      this.$store.state.mate.title = this.$i18n.t("message.Explorer_talent");
      this.$store.state.mate.description = this.$i18n.t("message.Explorer_desc");
      this.$store.state.mate.keywords = this.$i18n.t("message.Explorer_Keywords");
    },
    getCategoryList: function() {
      let that = this;
      this.api.getCategoryList({}, function(data) {
        that.categoryList = data.result;
      });
    }
  },
  computed: {
    _language() {
      return this.$store.state.language;
    }
  },
  watch: {
    _language() {
      this.selectIssue(this.magazineId, this.magazineItem, true);
    },
    magazineId() {
      this.getIssueContent(this.magazineId);
    }
  }
};
</script>